import { SVGProps } from "react"
const RentalHousingFormSuccessIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.1718 5.27482C52.222 3.92476 56.0752 7.77797 54.7251 11.8281L41.5155 51.4571C40.0441 55.8713 33.9511 56.2587 31.9325 52.0663L25.0405 37.7521C24.4529 36.5317 23.4682 35.5469 22.2477 34.9593L7.9337 28.0674C3.74132 26.0489 4.12863 19.9559 8.54289 18.4845L48.1718 5.27482ZM50.9444 10.5679C51.2559 9.63324 50.3667 8.74404 49.4321 9.05559L9.80315 22.2652C8.78448 22.6048 8.69508 24.0109 9.66257 24.4767L23.9766 31.3686C24.3836 31.5645 24.7748 31.787 25.1482 32.0338L36.1727 21.0093C36.9509 20.2311 38.2126 20.2311 38.9907 21.0093C39.7689 21.7875 39.7689 23.0492 38.9907 23.8273L27.9662 34.8519C28.2129 35.2252 28.4353 35.6163 28.6312 36.0232L35.5233 50.3374C35.9891 51.3049 37.3952 51.2155 37.7347 50.1968L50.9444 10.5679Z"
        fill={props.color || "#2768A3"}
      />
    </svg>
  )
}

export default RentalHousingFormSuccessIcon
